import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { TrackingListItem } from './components/TrackingListItem'

type Props = RenderItemProps<'tracking'>

export function Item(props: Props) {
  return props.type === 'item' ? <TrackingListItem {...props} /> : null
}
